import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {
    constructor(private httpClient: HttpClient, private translateService: TranslateService) { }

    getTranslation(lang: string): Observable<Record<string, string>> {
        lang = localStorage.getItem('LANGUAGE_CODE') ? localStorage.getItem('LANGUAGE_CODE') : 'en';

        return this.httpClient.get<Record<string, string>>(`./assets/i18n/${lang}.json`);
    }

    setLanguage(lang: string) {
        localStorage.setItem('LANGUAGE_CODE', lang);
        this.translateService.use(localStorage.getItem('LANGUAGE_CODE'));
    }

    getLanguage(): any {
        return localStorage.getItem('LANGUAGE_CODE') ? localStorage.getItem('LANGUAGE_CODE') : 'en';
    }

}
